import { render } from "./SidbarItem.vue?vue&type=template&id=c8cee30e&scoped=true"
import script from "./SidbarItem.vue?vue&type=script&lang=js"
export * from "./SidbarItem.vue?vue&type=script&lang=js"

import "./SidbarItem.vue?vue&type=style&index=0&id=c8cee30e&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\1h_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8cee30e"]])

export default __exports__